<template>
  <div class="wf-ideabook-banner">
    <img
      :src="ideabookdetail.pages.ideabookBackgroundImage.replace('~', '')"
      class="background-image"
      alt="IdeabookBackgroundImage"
    />
    <div class="container-fluid">
      <div class="wf-ideabook-banner-content">
        <div
          class="wf-ideabook-banner-content-section"
          :style="{
            backgroundColor: ideabookdetail.pages.ideabookBackgroundColor
          }"
        >
          <div class="p-5">
            <h1 class="display-3 text-white">
              {{ ideabookdetail.pages.ideabookTitle }}
            </h1>
            <h2>
              {{ ideabookdetail.pages.ideabookPublicationYear }} / Issue
              {{ ideabookdetail.pages.ideabookIssueNumber }}
            </h2>
            <div class="mb-2">
              {{ ideabookdetail.pages.ideabookDescription }}
            </div>
            <div
              class="py-3"
              v-if="!ideabookdetail.pages.ideabookHideAddToCartButton"
            >
              <div class="vue-wf-ecommerce-ideabook-state">
                <p>
                  {{ ideabookdetail.parent.ideabookFolderAddToBasketText }}
                </p>
                <wf-add-to-cart-idea-book-button
                  :selling-style-number="
                    ideabookdetail.pages.ideabookStyleNumber
                  "
                  :color-number="ideabookdetail.pages.ideabookColorNumber"
                  :vehicle-id="ideabookdetail.pages.ideabookVehicleId"
                  :button-text="'Add to basket'"
                  :trusted-user="ideabookdetail.isTrustedDetail"
                >
                </wf-add-to-cart-idea-book-button>
              </div>
            </div>
            <div class="py-3">
              <p>
                {{ ideabookdetail.parent.ideabookFolderDownloadPdfText }}
              </p>
              <a
                class="btn btn-primary justify-content-start"
                :href="ideabookdetail.pages.ideabookPdf.replace('~', '')"
                target="_blank"
              >
                <span
                  class="png-icon png-icon-icons-glyph--ko-btn-download"
                ></span>
                <span class="ml-2">
                  Download PDF
                </span>
              </a>
            </div>
          </div>
        </div>
        <div class="wf-ideabook-banner-content-section">
          <img
            :src="ideabookdetail.pages.ideabookCoverImage.replace('~', '')"
            class="w-100 img-fluid"
            alt="IdeabookBackgroundImage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WfAddToCartIdeaBookButton from "./../wf-add-to-cart-idea-book-button.vue";
export default {
  props: ["ideabookdetail"],
  components: {
    WfAddToCartIdeaBookButton
  }
};
</script>
